import { render, staticRenderFns } from "./PrkBasicSection.vue?vue&type=template&id=0a92167a&scoped=true&"
import script from "./PrkBasicSection.vue?vue&type=script&lang=js&"
export * from "./PrkBasicSection.vue?vue&type=script&lang=js&"
import style0 from "./PrkBasicSection.vue?vue&type=style&index=0&id=0a92167a&scoped=true&lang=scss&"
import style1 from "./PrkBasicSection.vue?vue&type=style&index=1&id=0a92167a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a92167a",
  null
  
)

export default component.exports